import { Component, ErrorInfo, ReactNode } from "react";

import AppErrorPage from "./AppErrorPage";
import { CHUNK_RELOAD_KEY, isChunkLoadError } from "src/utils/lazyRetry";

type ProductionErrorBoundaryProps = {
  children: ReactNode;
};

type ProductionErrorBoundaryState = {
  hasError: boolean;
};

class ProductionErrorBoundary extends Component<
  ProductionErrorBoundaryProps,
  ProductionErrorBoundaryState
> {
  public state: ProductionErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): ProductionErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(
      "Application error boundary caught an error",
      error,
      errorInfo,
    );

    if (
      isChunkLoadError(error) &&
      sessionStorage.getItem(CHUNK_RELOAD_KEY) === "true" &&
      window.location.pathname !== "/error"
    ) {
      window.location.assign("/error");
    }
  }

  public render() {
    if (this.state.hasError) {
      return <AppErrorPage />;
    }

    return this.props.children;
  }
}

export default ProductionErrorBoundary;
